import { Link as CLink, LinkProps as CLinkProps } from '@chakra-ui/react';
import * as React from 'react';

const Link = React.forwardRef<HTMLAnchorElement, CLinkProps>(
  ({ href, onClick, ...props }, ref) => {
    if (onClick) {
      return (
        <CLink
          color="primary.600"
          fontWeight="medium"
          onClick={onClick}
          ref={ref}
          cursor="pointer"
          {...props}
        />
      );
    }
    return (
      <CLink
        color="primary.600"
        fontWeight="medium"
        href={href}
        ref={ref}
        {...props}
      />
    );
  }
);

Link.displayName = 'Link';

export default Link;
